import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
//fb login
import './assets/application.js'

// Element
import '@/assets/theme/app.scss'
import ElementUI from 'element-ui'
Vue.use(ElementUI)

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
library.add(fas, far)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

// localForage
import localforage from 'localforage'
localforage.config({
    driver: localforage.LOCALSTORAGE,
    storeName: 'ortv'
})

// axios
import axios from 'axios'
axios.defaults.baseURL = 'https://teachers.studioclassroom.com/api'

axios.interceptors.request.use(config => {
  store.dispatch('loading/loader')
  return config
}, error => {
  store.dispatch('loading/loader', 'close')
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  store.dispatch('loading/loader', 'close')
  return response
}, error => {
  store.dispatch('loading/loader', 'close')
  return Promise.reject(error)
})


// when page refresh, check token
store.dispatch('auth/setToken')
  .then(() => {
    store.dispatch('auth/fetchUser')
  }).catch(() => {
    store.dispatch('auth/clearAuth')
  })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

